<div class="view-more" *ngIf="appId == 5" >
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0">
            <li class="breadcrumb-item"><a href="javascript:;" routerLink="/overview">Back to overview</a></li>
            <li class="breadcrumb-item active" aria-current="page">{{AppName}}</li>
        </ol>
    </nav>
    <div class="intro-text mb-0">
        <h4>{{AppName}}</h4>
        <p>Minimize cost of migration from competition and legacy HMI systems by automatically converting to our state of the art HMI solutions.</p>
        <p class="color-primary">Coming Soon</p>
    </div>
</div>


<div class="view-more" *ngIf="appId == 7">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0">
            <li class="breadcrumb-item"><a href="javascript:;" routerLink="/overview">Back to overview</a></li>
            <li class="breadcrumb-item active" aria-current="page">{{AppName}}</li>
        </ol>
    </nav>
    <div class="intro-text mb-0">
        <h4>{{AppName}}</h4>
        <p>A reverse-engineering tool allowing you to generate information from an existing PLC source code. Use PLC DocGen for maintenance, code review, audit or code debugging.</p>
        <p class="color-primary">Coming Soon</p>
    </div>
</div>

<div class="view-more" *ngIf="appId == 6">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0">
            <li class="breadcrumb-item"><a href="javascript:;" routerLink="/overview">Back to overview</a></li>
            <li class="breadcrumb-item active" aria-current="page">{{AppName}}</li>
        </ol>
    </nav>
    <div class="intro-text mb-0">
        <h4>{{AppName}}</h4>
        <p>A static analysis tool that allows you to maintain the quality of your PLC programs and save time. Use PLC Checker for audits, code reviews, compliance, and controlling program quality.</p>
        <p class="color-primary">Coming Soon</p>
    </div>
</div>